import React, { useState, useEffect } from "react";
import {
  Button,
  FormControl,
  FormLabel,
  TextField,
  Typography,
  Select,
  MenuItem,
  InputAdornment,
  IconButton,
} from "@material-ui/core";
import useStyles from "../../../../styles";
import axios from "axios";
import { decryptData } from "../../../../crypto";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import { Autocomplete } from "@mui/material";
import AssignQuestion from "./AssignQuestion";

function TransferQuestion() {
  const classes = useStyles();

  const menuProps = {
    getContentAnchorEl: null,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "left",
    },
    disablePortal: true,
  };

  const decryptedToken = decryptData(sessionStorage.getItem("token"));
  const navigate = useNavigate();
  const handleClose = () => {
    navigate("/admin/dashboard");
  };

  const [exams, setExams] = useState([]);
  const [targetedSubject, setTargetedSubject] = useState([]);
  const [subject, setSubject] = useState([]);

  const [selectedExam, setSelectedExam] = useState(null);
  const [selectedExamId, setSelectedExamId] = useState("");

  const [selectedTargetExamId, setSelectedTargetExamId] = useState(null);
  const [selectedTargetExam, setSelectedTargetExam] = useState("");

  const [selectedTargetedSubject, setSelectedTargetedSubject] = useState(null);
  const [selectedTargetedSubjectId, setSelectedTargetedSubjectId] =
    useState("");

  const [selectedSubject, setSelectedSubject] = useState(null);
  const [selectedSubjectId, setSelectedSubjectId] = useState("");

  const [right, setRight] = useState([]);

  const fetchExams = async () => {
    try {
      const decryptedToken = decryptData(sessionStorage.getItem("token"));

      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/exam`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
            // Add other headers if needed
          },
        }
      );

      if (response.ok) {
        const data = await response.json();
        setExams(data.exams);
      } else {
        console.error("Failed to fetch exam data");
      }
    } catch (error) {
      console.error("Error fetching exam data:", error);
    }
  };

  useEffect(() => {
    fetchExams();
  }, []);

  const fetchTargetedSubject = async () => {
    try {
      const decryptedToken = decryptData(sessionStorage.getItem("token"));

      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/subject/by_exam/${selectedTargetExamId}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
            // Add other headers if needed
          },
        }
      );

      if (response.ok) {
        const data = await response.json();
        setTargetedSubject(data.subjects);
      } else {
        console.error("Failed to fetch exam data");
      }
    } catch (error) {
      console.error("Error fetching exam data:", error);
    }
  };

  useEffect(() => {
    fetchTargetedSubject();
  }, [selectedTargetExamId]);

  const fetchSubject = async () => {
    try {
      const decryptedToken = decryptData(sessionStorage.getItem("token"));

      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/subject/by_exam/${selectedExamId}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
            // Add other headers if needed
          },
        }
      );

      if (response.ok) {
        const data = await response.json();
        setSubject(data.subjects);
      } else {
        console.error("Failed to fetch exam data");
      }
    } catch (error) {
      console.error("Error fetching exam data:", error);
    }
  };

  useEffect(() => {
    fetchSubject();
  }, [selectedExamId]);

  const handleExamChange = (event, value) => {
    setSelectedExamId(value.id);
    setSelectedExam(value);
    setSelectedSubjectId("");
    setSelectedSubject(null);
  };

  const handleTargetExamChange = (event, value) => {
    setSelectedTargetExamId(value.id);
    setSelectedTargetExam(value);
  };

  const handleSubjectChange = (event, value) => {
    setSelectedSubjectId(value.id);
    setSelectedSubject(value);
  };

  const handleTargetSubjectChange = (event, value) => {
    setSelectedTargetedSubjectId(value.id);
    setSelectedTargetedSubject(value);
  };

  console.log("right", right);

  const handleFormSubmit = () => {
    const ids = right.map((value) => value.id);
    console.log("idsidsidsids", ids, ids.length, ids.length > 0);
    if (!selectedTargetExamId) {
      toast.warn("Please select a Targeted Exam.");
      return;
    }

    if (!selectedTargetedSubjectId) {
      toast.warn("Please select a Targeted Subject.");
      return;
    }

    if (ids.length === 0) {
      toast.warn("Please select a At least one question.");
      return;
    }

    const data = {
      data: {
        exam_id: selectedTargetExamId,
        subject_id: selectedTargetedSubjectId,
        question_ids: ids,
      },
    };

    axios
      .post(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/question/copy/multiple/question`,
        data,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        setSelectedExamId("");
        setSelectedExam(null);
        setSelectedSubjectId("");
        setSelectedSubject(null);
        setRight([]);
        toast.success(`Transfer Question Successfully`);
      })
      .catch((error) => {
        toast.error(`Failed to update Transfer Question`);
      });
  };

  return (
    <>
      <ToastContainer />

      <div
        className={`${classes.inputpadding} ${classes.inputborder} ${classes.pagescroll} ${classes.maxh76}`}
      >
        <FormControl className={`${classes.w100}`}>
          <div
            className={`${classes.bgwhite} ${classes.boxshadow3} ${classes.borderradius6px} ${classes.py1} ${classes.px1_5} ${classes.mt1}`}
          >
            <div className={`${classes.dflex} ${classes.justifyspacebetween}`}>
              <Typography
                className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                variant="h6"
                display="inline"
              >
                Transfer Exam
              </Typography>

              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w36_6}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Targeted Exam <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <Autocomplete
                  id="state-autocomplete"
                  options={exams || []}
                  value={selectedTargetExam}
                  classes={{ inputRoot: classes.inputRoot }}
                  onChange={handleTargetExamChange}
                  disableClearable
                  getOptionLabel={(option) => option?.exam_name || ""}
                  autoHighlight
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Select Here"
                      variant="outlined"
                    />
                  )}
                  selectOnFocus
                  openOnFocus
                />
              </div>

              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w36_6}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Targeted Subject{" "}
                  <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <Autocomplete
                  id="state-autocomplete"
                  options={targetedSubject || []}
                  value={selectedTargetedSubject}
                  classes={{ inputRoot: classes.inputRoot }}
                  onChange={handleTargetSubjectChange}
                  disableClearable
                  getOptionLabel={(option) => option?.subject_name || ""}
                  autoHighlight
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Select Here"
                      variant="outlined"
                    />
                  )}
                  selectOnFocus
                  openOnFocus
                />
              </div>
            </div>
          </div>

          <div
            className={`${classes.bgwhite} ${classes.mt1} ${classes.boxshadow3} ${classes.borderradius6px} ${classes.py1} ${classes.px1_5} ${classes.mt1}`}
          >
            <div className={`${classes.dflex} ${classes.justifyspacebetween}`}>
              <Typography
                className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                variant="h6"
                display="inline"
              >
                Transfer Exam From
              </Typography>

              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w36_6}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal}
               ${classes.fw400} ${classes.lineheight}`}
                >
                  Exam <span className={classes.textcolorred}>*</span>
                </FormLabel>

                <Autocomplete
                  id="state-autocomplete"
                  options={exams || []}
                  value={selectedExam}
                  classes={{ inputRoot: classes.inputRoot }}
                  onChange={handleExamChange}
                  disableClearable
                  getOptionLabel={(option) => option?.exam_name || ""}
                  autoHighlight
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Select Here"
                      variant="outlined"
                    />
                  )}
                  selectOnFocus
                  openOnFocus
                />
              </div>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w36_6}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Subject <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <Autocomplete
                  id="state-autocomplete"
                  options={subject || []}
                  value={selectedSubject}
                  classes={{ inputRoot: classes.inputRoot }}
                  onChange={handleSubjectChange}
                  disableClearable
                  getOptionLabel={(option) => option?.subject_name || ""}
                  autoHighlight
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Select Here"
                      variant="outlined"
                    />
                  )}
                  selectOnFocus
                  openOnFocus
                />
              </div>
            </div>
            <div className={`${classes.dflex} ${classes.justifyspacebetween}`}>
              <AssignQuestion
                selectedExamId={selectedExamId}
                selectedSubjectId={selectedSubjectId}
                right={right}
                setRight={setRight}
              />
            </div>
          </div>
        </FormControl>
      </div>
      <div
        className={`${classes.dflex} ${classes.justifyflexend} ${classes.mt1}`}
      >
        <Button className={`${classes.custombtnoutline}`} onClick={handleClose}>
          Cancel
        </Button>
        <Button
          className={`${classes.custombtnblue}`}
          onClick={handleFormSubmit}
        >
          Submit
        </Button>
      </div>
    </>
  );
}
export default TransferQuestion;
